import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/delta/video-poster.webp")